<template>
<div class="container-fluid">

  

  <div class="container-fluid bg-ubicacion">
    <div class="row border-bottom regente-plan-item pt-3 pb-3">
      <div class="col-12 col-md-12">  
        <b-tabs content-class="mt-3 mb-3">          
          <b-tab >
            <template #title>
              <font-awesome-icon icon="user-tie" class=""/>{{$t('plan_page_detalle_acotres_invo')}}  
            </template>

            <div class="row regente-plan-detail pt-5">
      <div class="col-12 col-md-4">
        <MapaDepartamento :departamento="departamento"></MapaDepartamento>
      </div>

      <div class="col-12 col-md-8">
        <div class="row mb-3">
          <div class="col-12 col-md-6">
            <label class="label-planes"><font-awesome-icon icon="user-tie" class=""/>{{$t('plan_page_detalle_titular')}}</label>
            <h5>{{ plan.titular_actual }}</h5>

            <label class="label-planes mt-3"><font-awesome-icon icon="user-tie" class=""/>{{$t('plan_page_detalle_representante')}}</label>
            <h5>{{ plan.representante_legal }}</h5>
          </div>
          <div class="col-12 col-md-6">
            <label class="label-planes"><font-awesome-icon icon="folder" class=""/>{{$t('plan_page_detalle_num_th')}}</label>
            <h5>{{plan.numero_th}}</h5>
            <label class="label-planes mt-3"><font-awesome-icon icon="user-tie" class=""/>{{$t('plan_page_detalle_modalidad')}}</label>
            <h5>{{ translate_modalidad(plan.modalidad) }}</h5>
          </div>
        </div>
        
       
        <div class="row mb-3">

          <div class="col-12 col-md-6">
            <label class="label-planes"><font-awesome-icon icon="folder" class=""/>{{$t('plan_page_detalle_tipo_pmf')}}</label>
            <h5>{{ plan.nombre_poa }}</h5>
            <label class="label-planes"><font-awesome-icon icon="folder" class=""/>{{$t('plan_page_detalle_resolucion')}}</label>
            <h5>{{ plan.resolucion_poa }}</h5>
            <label class="label-planes"><font-awesome-icon icon="chart-area" class=""/>{{$t('plan_page_detalle_area')}}</label>
            <h5>{{ plan.area_plan_manejo }}<span class="ml-1">{{$t('plan_page_detalle_ha')}}</span></h5>
          </div>

          <div class="col-12 col-md-6">
            
            <label class="label-planes"><font-awesome-icon icon="chart-area" class=""/>{{$t('plan_page_detalle_caducidad')}}</label>
            <h5>{{$t('plan.caducidad_del_th')}}</h5>
            <label class="label-planes"><font-awesome-icon icon="chart-area" class=""/>{{$t('plan_page_detalle_area')}}</label>
            <h5>{{ plan.area_th | numFormat }}<span class="ml-1">{{$t('plan_page_detalle_ha')}}</span></h5>
          </div>
        </div>
       
        <div class="row mb-3">
          <div class="col-12">
            <label class="label-planes">{{$t('plan_page_detalle_distri_prov_dep')}}</label>
            <h5>{{plan.distrito}} / {{ plan.provincia }} / {{ plan.departamento }}</h5>
          </div>
        </div>
        <div class="row">
          

        </div>

      </div>

    </div>

          </b-tab>
          <b-tab >
            <template #title>
              <font-awesome-icon icon="user-tie" class=""/>{{$t('plan_page_detalle_acotres_invo')}}  
            </template>

            <div class="row involucrados-panel">
              <div class="col-12 col-md-4">
                
                <div class="mb-3" v-if="plan.representante_legal_id">
                  <label class="label-planes">{{$t('plan_page_detalle_repre_legal')}}</label>
                  <h5 v-if="plan.representante_legal != '*No indica'">
                    

                     <router-link :to="{ name: 'InvolucradoPage', params:{ id: get_slug(plan.representante_legal_id)}}" >{{plan.representante_legal}}</router-link>
                  </h5>

                  <h5 v-if="plan.representante_legal == '*No indica'">{{$t('plan_detalle_h5')}}</h5>
                </div>


                <div class="mb-3" v-if="plan.consultor_pmf_id">
                  <label class="label-planes">{{$t('plan_detalle_consultor')}}</label>
                  <h5 v-if="plan.consultor_pmf != '*No indica'">
                    
                  <router-link :to="{ name: 'InvolucradoPage', params:{ id: get_slug(plan.consultor_pmf_id)}}" >{{ plan.consultor_pmf }}</router-link>
                     
                  </h5>
                  <h5 v-if="plan.consultor_pmf == '*No indica'">{{$t('plan_detalle_consult_h5')}}</h5>
                </div>

                <div class="mb-3" v-if="plan.profesional_inf_tecnico_insp_ocular">
                  <label class="label-planes">{{$t('plan_detalle_profesional')}}</label>
                  <h5 v-if="plan.profesional_inf_tecnico_insp_ocular != 'ND'">
                    <router-link :to="{ name: 'InvolucradoPage', params:{ id: get_slug(plan.profesional_inf_tecnico_insp_ocular_id)}}" >{{ plan.profesional_inf_tecnico_insp_ocular }}</router-link>
                  </h5>
                  <h5 v-if="plan.profesional_inf_tecnico_insp_ocular == 'ND'">{{$t('plan_detalle_prof_h5')}}</h5>
                </div>


              </div>
              <div class="col-12 col-md-4">
                <div class="mb-3" v-if="plan.profesional_recomienda_aprueba_pmf_id">
                  <label class="label-planes">{{$t('Plan_detalle_profe_reco_aprob')}}</label>
                  <h5 v-if="plan.profesional_recomienda_aprueba_pmf != 'ND'">
                    
                     <router-link :to="{ name: 'InvolucradoPage', params:{ id: get_slug(plan.profesional_recomienda_aprueba_pmf_id)}}" > {{ plan.profesional_recomienda_aprueba_pmf }}</router-link>
                  </h5>
                  <h5 v-if="plan.profesional_recomienda_aprueba_pmf == 'ND'">{{$t('plan_detalle_prof_reco_h5')}}</h5>
                </div>

                <div class="mb-3" v-if="plan.funcionario_aprobo_pmf">
                  <label class="label-planes">{{$t('plan_detalle_func_aprob_plan')}}</label>
                  <h5 v-if="plan.funcionario_aprobo_pmf != 'ND'">
                  
                    <router-link :to="{ name: 'InvolucradoPage', params:{ id: get_slug(plan.funcionario_aprobo_pmf_id)}}" >  {{ plan.funcionario_aprobo_pmf }}</router-link>
                  </h5>
                  <h5 v-if="plan.funcionario_aprobo_pmf == 'ND'">{{$t('plan_page_detalle_h5')}}</h5>
                </div>
                

              </div>
              
            </div>

          </b-tab>
          <b-tab >
            <template #title>
              <font-awesome-icon icon="user-tie" class=""/>{{$t('Datos de la supervision')}}  
            </template>

            <div class="row involucrados-panel">
              <div class="col-12 col-md-4">
                
                <div class="mb-3" v-if="plan.nro_informe">
                  <label class="label-planes">{{$t('plan_detalle_num_info_sup')}}</label>
                  <h5>
                    

                     <router-link :to="{ name: 'InvolucradoPage', params:{ id: get_slug(plan.nro_informe)}}" >{{plan.nro_informe}}</router-link>
                  </h5>

                  <h5 v-if="plan.nro_informe == '*No indica'">{{$t('plan_detalle_num_info_sup')}}</h5>
                </div>


                <div class="mb-3" v-if="plan.fecha_sup_raw">
                  <label class="label-planes mt-3">{{$t('plan_detalle_fecha_sup')}}</label>
                  <h5 v-if="plan.fecha_sup_raw != '*No indica'">
                    
                  <router-link :to="{ name: 'InvolucradoPage', params:{ id: get_slug(plan.fecha_sup_raw)}}" >{{ plan.fecha_sup_raw }}</router-link>
                     
                  </h5>
                  <h5 v-if="plan.fecha_sup_raw == '*No indica'">{{$t('plan_detalle_fecha_sup')}}</h5>
                </div>
                <div>
                    <label class="label-planes"><font-awesome-icon icon="file-download" class="mr-1"/>{{$t('plan_detalle_descarga')}}</label>
                  
                    <ul class="pl-3">
                      <li v-if="plan.link_informe"><a target="_blank" :href="`${plan.link_informe}.pdf`">{{$t('plan_detalle_info_sup')}}</a></li>
                      <li v-if="plan.pdf_rd_inicio_pau"><a target="_blank" :href="plan.pdf_rd_inicio_pau" class="">{{$t('plan_detalle_reso_ini')}}</a></li>
                      <li v-if="plan.pdf_termino_pau"><a target="_blank" :href="plan.pdf_termino_pau" class="">{{$t('plan_detalle_termi_pau')}}</a></li>
                    </ul>

                </div>
                
              </div>
              <div class="col-12 col-md-4 pt-md-0 pt-3 mb-3">
                <div class="row">
                  <div class="col-6 col-md-12 text-center">
                    <h5 class="datos-informe">{{plan.arboles_aprobados | numFormat}}</h5>                
                    <label class="label-planes"><font-awesome-icon icon="tree" class="mr-1"/>{{$t('plan_detalle_arboles_aprob')}}</label>
                  </div>
                  <div class="col-6 col-md-12 mt-md-3 mt-0 text-center">
                    <h5 class="datos-informe">{{plan.cant_especies_aprobada | numFormat}}</h5>                
                    <label class="label-planes"><font-awesome-icon icon="seedling" class="mr-1"/>{{$t('plan_detalle_especies_aprob')}}</label>   
                  </div>
                </div>
              </div>              
              
              <div class="col-12 col-md-8 text-left">
                <label class="label-planes"><font-awesome-icon icon="tree" class="mr-1"/>{{$t('plan_detalle_muestra_sup')}}</label>
                <div class="arboles-supervisados">
                 <h5 class="">{{ plan.mues_seleccionada_pmf | numFormat }} {{$t('plan_detalle_arboles')}}</h5>                  
                </div>  
                <label class="label-planes mt-3"><font-awesome-icon icon="tree" class="mr-1"/>{{$t('plan_detalle_inex_sup')}}</label>
                <div class="arboles-inexistentes" :style="`width:`+calcularInexistentes(plan)+`%`">
                  <h5 class="">{{ calcularInexistentes(plan) | numFormat }}{{$t('plan_page_detalle_percent')}} ({{ plan.individuos_inexistentes }} {{$t('plan_detalle_inex_arboles')}})</h5>
                   
                </div>
              </div>
              <div class="row featured-block pt-5 pb-5 text-center">
              <div class="col-6 col-md-3">                 
                <h5 class="datos-detalle">{{ plan.vol_aprobado | numFormat }} <span class="medida ml-1">{{$t('plan_page_detalle_m3')}}</span></h5>             
                <label class="label-planes"><font-awesome-icon icon="chart-bar" class="mr-1"/>{{$t('plan_detalle_vol_aprob')}}</label>                              
              </div>
              <div class="col-6 col-md-3">                                
                  <h5 class="datos-detalle">{{ plan.vol_movilizado | numFormat }} <span class="medida ml-1">{{$t('plan_page_detalle_m3')}}</span></h5>
                  <label class="label-planes"><font-awesome-icon icon="chart-bar" class="mr-1"/>{{$t('plan_detalle_vol_movi')}}</label>
              </div>
              <div class="col-6 col-md-3">
                  <h5 v-if="plan.vol_justificado != 'ND' " class="datos-detalle">{{plan.vol_justificado | numFormat}} <span class="medida ml-1">{{$t('plan_page_detalle_m3')}}</span></h5> 
                  <h5 v-if="plan.vol_justificado == 'ND'" class="datos-detalle">{{$t('plan_page_detalle_h5')}}</h5>
                  <label class="label-planes"><font-awesome-icon icon="chart-pie" class="mr-1"/>{{$t('plan_detalle_vol_justi')}}</label>
              </div>
              <div class="col-6 col-md-3">                    
                  <h5 v-if="plan.vol_injustificado != 'ND' "  class="datos-detalle">{{ plan.vol_injustificado | numFormat }} <span class="medida ml-1">m3</span></h5>
                  <h5 v-if="plan.vol_injustificado === 'ND'" class="datos-detalle">{{$t('plan_page_detalle_h5')}}</h5>
                 <label class="label-planes"><font-awesome-icon icon="question-circle" class="mr-1"/>{{$t('plan_Detalle_vol_inju')}}</label> 
              </div>
            </div>  
            </div>

          </b-tab>
        </b-tabs>
      </div>
    </div>
  </div> 

</div>
</template>

<script>
  import { find } from 'lodash'
  import slugify from 'slugify'
  import MapaDepartamento from '../components/MapaDepartamento.vue'
  

  export default {
    name: 'PlanPageWidget',
    props: {
      dataset: {
        type: Array
      }
    },
    components: {
      MapaDepartamento
    },
    methods: {
      get_slug(id) {
        return slugify(id).toLowerCase()
      },
      calcularInexistentes(plan) {
        return (plan.individuos_inexistentes/plan.mues_seleccionada_pmf)*100
      },
      translate_modalidad(m) {
        const modalidad= (m).replace(' ','_').toLowerCase().replace('-','_')
          return this.$t(modalidad.replace(' ','_'))
      }
    },
    computed: {
      departamento() {
        return {
          nombre: this.plan.departamento,
          distritos: [this.plan.distrito]
        }
      },      
      plan() {
        return find(this.dataset,['resolucion_poa_id', this.$route.params.id])
      }
    }
  }
</script>